import "./MenuTitle.scss";

import { Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsLeftRight } from "@fortawesome/free-solid-svg-icons";

function MenuTitle({ title, showArrowInfo = false }) {


    return (
        <Col xs={12}>
            <div className="companies-header">
                <h2 className="hallapp-title" style={{ marginBottom: 8, fontSize: 20 }}>
                    {title}
                </h2>
                <div className="divider" />

                { showArrowInfo &&
                    <> 
                        <div className="hint hint--brand">
                            <FontAwesomeIcon icon={faArrowsLeftRight} />
                            <span>
                                Arraste: <b>direita</b> para excluir, <b>esquerda</b> para editar.
                            </span>
                        </div>
                        <div className="divider" />
                    </>
                }
            </div>
        </Col>
    );
}

export default MenuTitle;